import { useState, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useEventHub } from '@pwc/event-hub-ui';
import { Loader } from '@pwc/pwc-deals-ui';
import { getIsDarkModeSelector } from 'common/redux/userSettings/userSettingsSlice';
import { getEngagementId } from 'features/project/projectSlice';
import { useFederatedComponent } from './mfe-loader.util';
import { prepareUMMFEProps, umMfeFn } from './userManagementUtil';
import styles from './userManagement.module.scss';

const UserManagement = () => {
  // This parentId is consumed by UM-MFE and injects the mfe to this parentId
  const parentId = 'um-mfe-node';
  const { projectId }: { projectId: string } = useParams();
  const [loading, setLoading] = useState(true);
  const engagementId = useSelector(getEngagementId);
  const location = useLocation();

  const { injectFunc, cleanupFunc } = useFederatedComponent(
    'REACT_APP_USER_MANAGEMENT_MFE_URL',
    'cde_core_um_mfe',
    './Module'
  );

  const isUserThemeDarkMode = useSelector(getIsDarkModeSelector) as boolean;
  const { eventHub } = useEventHub();
  const language = eventHub?.getCurrentLang();
  useEffect(() => {
    const props = prepareUMMFEProps(
      projectId,
      isUserThemeDarkMode,
      engagementId,
      language
    );

    if (injectFunc) {
      injectFunc(parentId, props);
      setLoading(false);
    }

    if (cleanupFunc) {
      umMfeFn.cleanUpFunc = cleanupFunc;
    }

    return () => {
      if (cleanupFunc) {
        cleanupFunc(parentId);
      }
    };
  }, [
    injectFunc,
    cleanupFunc,
    projectId,
    isUserThemeDarkMode,
    engagementId,
    location,
    language,
  ]);

  return (
    <div>
      {loading ? <Loader /> : ''}
      <div className={styles['user-management-container']} id={parentId} />
    </div>
  );
};

export default UserManagement;
